module.exports = __webpack_public_path__ + "static/media/Locale.0263c973.png";